<div class="col-sm-6 esquerda">

    <div *ngIf="!showLoaderMidia" class="area-midias">
        <div class="d-flex justify-content-center">
            <!-- <img [src]="capaUrl" class="w-100 img-capa"> -->
             <img src="assets/img/final.jpeg" class="img-final">
        </div>
    </div>

    <div *ngIf="showLoaderMidia" class="d-grid align-items-center justify-content-center">
        <loader-page [show]="true"></loader-page>
    </div>
</div>
<div class="col-sm-6 direita">
    <div class="d-grid align-items-center">
        <div class="w-100">
            <h2 class="titulo">{{teste?.nome}}</h2>
            <h1 class="titulo" style="font-size: 1.5em;">Parabens, você finalizou o Mindtest Liderança e IA!</h1>
        </div>

        <!-- <div class="descricao"> -->
        <!-- <p [innerHTML]="teste?.descricao | safeHtmlJogada"></p> -->
        <!-- </div> -->

        <div>
            <div class="btn-relatorio">
                <a class="cta report" (click)="relatorio()">📄 Ver Relatório</a>
            </div>

            <!-- <div class="btn-relatorio">
                <a class="cta insights" (click)="recomendacoes()">⭐ Recomendações</a>
            </div> -->
        </div>

        <!-- <btn-continuar *ngIf="teste" texto="Concluir" (click)="onClickContinuar()" class="mt-4"></btn-continuar> -->
    </div>
</div>